<div class="desc_container">
  <span class="desc">{{ description }}
  </span>
  <span class="clearBtn" (click)="onClearGST()">Clear</span>
</div>
<app-dynamic-form-landing [formSections]="formSections" [showButtons]="false" [valuesToPatch]="formValues"
  (closeCalenderEvent)="onIsClose($event)" (fieldValueChanged)="onFieldValueChanged($event)"></app-dynamic-form-landing>
<div *ngIf="showFetchError" class="error-message">
  * Gst number is not valid
</div>
<div class="btn_container" [ngStyle]="{'margin-bottom': '24px'}">
  <button class="btn btn-secondary-outline btn-lg fetch_gst" (click)="onFetchGst()"
    [disabled]="showFetchError || !enableButton">Fetch
    GST</button>
  <button class="btn btn-danger-outline btn-lg fetch_gst" (click)="onRemoveGst()" [disabled]="!enableButton">Remove
    GST</button>
</div>
<div class="btn_container seperated">
  <button class="btn btn-danger-outline btn-lg" (click)="onCancel()">Cancel</button>
  <button class="btn btn-primary btn-lg" (click)="onSubmit()" [appProgressButton]="false" [buttonText]="'Save'"
    [disabled]="!enableButton">
    Save
  </button>
</div>